import { Card } from "pws-design-system/design-system";
import React from "react";

export interface DisplayVariantCardProps {}

const DisplayVariantCard: React.FC<DisplayVariantCardProps> = (props): React.ReactElement => {
  return (
    <Card
      boxShadow="sm"
      mb={3}
      p={3}
      position="relative"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      {...props}
    >
      <div>Data could not be displayed at this time.</div>
    </Card>
  );
};

export default DisplayVariantCard;
